import * as React from 'react';

function SvgStar(props) {
  return (
    <svg viewBox="0 0 612 792" width="1em" height="1em" {...props}>
      <path
        fill="#fcaf17"
        d="M306 153l-89.6 145.9L50 339l111 130.3-13.2 170.6L306 574.6l158.2 65.3L451 469.3 562 339l-166.4-40.1L306 153z"
      />
    </svg>
  );
}

export default SvgStar;
